/**
 * @generated SignedSource<<69144ced3442ad9da1b6463adb889ab9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteFileInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type FileIsUsedInNodeAttachmentsDialog_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteFileInput;
};
export type FileIsUsedInNodeAttachmentsDialog_DeleteMutation$data = {
  readonly Admin: {
    readonly Files: {
      readonly deleteFile: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type FileIsUsedInNodeAttachmentsDialog_DeleteMutation = {
  response: FileIsUsedInNodeAttachmentsDialog_DeleteMutation$data;
  variables: FileIsUsedInNodeAttachmentsDialog_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FileIsUsedInNodeAttachmentsDialog_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FilesAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Files",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteFilePayload",
                "kind": "LinkedField",
                "name": "deleteFile",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FileIsUsedInNodeAttachmentsDialog_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FilesAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Files",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteFilePayload",
                "kind": "LinkedField",
                "name": "deleteFile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4780230b5b441d69a7ae88c3e40bd141",
    "id": null,
    "metadata": {},
    "name": "FileIsUsedInNodeAttachmentsDialog_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FileIsUsedInNodeAttachmentsDialog_DeleteMutation(\n  $input: DeleteFileInput!\n) {\n  Admin {\n    Files {\n      deleteFile(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a51e95e0f2bcf764e3564c22097d303";

export default node;
